// extracted by mini-css-extract-plugin
export default {"h":"styles_h__EfrT9","p":"styles_p__yDEno","box":"styles_box__J-Jta"};